import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import { FinancialInstrumentsFields } from './FinancialInstrumentsFields';
import { InformationAboutOperationsFields } from './InformationAboutOperationsFields';
import { Section } from './Section';

export const FormContent = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={48} spacingMobile={36}>
      <Section
        title={t(
          'onboarding.targetedFinancialInstruments.financialInstruments.title'
        )}
      >
        <FinancialInstrumentsFields />
      </Section>

      <Section
        title={t(
          'onboarding.targetedFinancialInstruments.informationAboutOperations.title'
        )}
      >
        <InformationAboutOperationsFields />
      </Section>
    </Stack>
  );
};
